import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Card } from '@uhg-abyss/web/ui/Card';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import React from 'react';

/**
 * NotFound
 *
 * This component is used to display a not found message.
 *
 * @param button
 * @param icon
 * @param message
 * @param title
 * @returns {Element}
 * @constructor
 */
export function NotFound({ button = null, icon = '', message = '', title = '' }) {
  return (
    <ErrorHandler location="src/shared/ui/components/NotFound/NotFound.jsx">
      <Layout.Group
        alignLayout="center"
        css={{
          padding: `calc(var(--abyss-space-lg) * 4) 0px`,
        }}
      >
        <Card
          css={{
            borderStyle: 'dashed',
            boxShadow: 'none',
          }}
        >
          <Layout.Stack
            css={{
              padding: `calc(var(--abyss-space-lg) * 2) calc(var(--abyss-space-xl) * 4)`,
            }}
            space={0}
          >
            <IconSymbol color="var(--abyss-colors-gray5)" icon={icon} size="48px" variant="outlined" />
            <div>
              <strong>{title}</strong>
            </div>
            <div>{message}</div>
            <div style={{ marginTop: 'var(--abyss-space-lg)' }}>{button}</div>
          </Layout.Stack>
        </Card>
      </Layout.Group>
    </ErrorHandler>
  );
}
